import { useEffect } from 'react';
import axios from 'axios';
import { UserControllerApi } from '../api/generated';
import { createApiConfiguration } from '../api/apiConfig';
import { useAppDispatch } from '../store/hooks';
import { setGlobalAdmin } from '../store/permissions/permissionsSlice';

export function useFetchGlobalAdmin(): void {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const controller = new AbortController();
    const api = new UserControllerApi(createApiConfiguration());

    api
      .getCurrentUserGlobalAdmin({ signal: controller.signal })
      .then((response) => {
        dispatch(setGlobalAdmin({ globalAdmin: response.data.globalAdmin ?? false }));
      })
      .catch((err: unknown) => {
        if (axios.isCancel(err)) return;
        dispatch(setGlobalAdmin({ globalAdmin: false }));
      });

    return () => {
      controller.abort();
    };
  }, [dispatch]);
}
